'use strict';
(function initializeCampaignSettingRecentAdapter(root) {
  const app = root.dndNextLevel;
  const state = app.campaignSettingState;
  const TYPE = 'campaign-setting';
  const RESTORE_KEY = 'dnd-next-level:campaign-setting:restore:v1';
  const MIGRATION_KEY = 'dnd-next-level:campaign-setting:recent-migrated:v1';

  const clone = value => JSON.parse(JSON.stringify(value));
  const documentFrom = source => {
    if (state.isCanonical(source?.document)) return source.document;
    if (state.isCanonical(source)) return source;
    const raw = source?.querySelector?.('[data-persisted-fragment-document]')
      ?.dataset?.persistedFragmentDocument;
    const parsed = state.parseObject(raw);
    return state.isCanonical(parsed) ? parsed : null;
  };
  const capture = source => {
    const document = documentFrom(source);
    return document ? {version: 2, document: clone(document)} : null;
  };
  const validate = payload => payload?.version === 2 && state.isCanonical(payload.document);
  const label = value => String(value || '')
    .toLowerCase().split('_').map(word => word ? word[0].toUpperCase() + word.slice(1) : '')
    .join(' ');
  const adapter = {
    type: TYPE,
    route: '/campaign-setting',
    capture,
    validate,
    preview(payload) {
      if (!validate(payload)) throw new Error('Invalid Campaign Setting recent creation');
      const document = payload.document;
      return {
        title: document.campaign.settingName || 'Unnamed campaign',
        description: [label(document.campaign.resolvedGenre), document.access.editable ? 'Editable' : 'Player view'].join(' · '),
      };
    },
    restore(payload) {
      if (!validate(payload)) throw new Error('Invalid Campaign Setting recent creation');
      root.localStorage.setItem(state.currentKey(), JSON.stringify(payload.document));
      root.location.assign(adapter.route);
      return payload.document;
    },
  };
  const sharedStore = storage => app.recentCreationStore.create(storage);
  const readShared = storage => sharedStore(storage).read().filter(entry => entry.type === TYPE);
  const saveCurrent = (source, storage = root.localStorage, pinned = false, now = Date.now()) => {
    const payload = capture(source);
    if (!validate(payload)) return null;
    const store = sharedStore(storage);
    const previous = store.read().find(entry => entry.type === TYPE && entry.id === 'current');
    const entry = {
      id: 'current', type: TYPE,
      createdAt: previous?.createdAt ?? now, updatedAt: now,
      pinned: pinned || previous?.pinned === true, payload,
    };
    store.save(entry);
    app.recentCreations?.instance?.render();
    return entry;
  };
  const consumeRestore = (storage = root.localStorage, sessionStorage = root.sessionStorage) => {
    const raw = sessionStorage.getItem(RESTORE_KEY);
    sessionStorage.removeItem(RESTORE_KEY);
    const queued = state.parseObject(raw);
    if (!queued) return null;
    let document = validate(queued) ? queued.document : null;
    if (!document && queued.version === 1 && queued.campaign) {
      const editable = queued.access?.locked !== true;
      const access = editable
        ? {exportDmSecrets: queued.access?.dmSecrets !== false, editable: true}
        : {exportDmSecrets: false, editable: false};
      document = state.canonicalFromCampaign(
        queued.campaign,
        access,
        editable && queued.locks?.version === 1 ? queued.locks : state.emptyLocks()
      );
    }
    if (!state.isCanonical(document)) return null;
    storage.setItem(state.currentKey(), JSON.stringify(document));
    return document;
  };
  const migrateLegacy = (storage = root.localStorage) => {
    if (storage.getItem(MIGRATION_KEY)) return null;
    storage.setItem(MIGRATION_KEY, '1');
    return null;
  };

  app.campaignSettingRecentAdapter = {
    adapter, readShared, saveCurrent, consumeRestore, migrateLegacy,
    RESTORE_KEY, MIGRATION_KEY,
  };
  app.recentCreationAdapters?.registry?.register(adapter);
})(window);
